import { Box, Grid } from "@mui/material";
import styled from "styled-components";
import { removeSpecialCharacters } from "../../utilities/common";
import { useEffect, useState } from "react";
import { getViewerUrls } from "../../store/actions/records.action";
import { useDispatch } from "react-redux";
import { ShimmerTitle } from "react-shimmer-effects";

const FileName = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0.7rem;
`;

const ListItemWrapper = styled.div`
  padding: 0px;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s;
  width: 100%;
`;

const ThumbImages = styled.div`
  position: relative;
  background: #ebf7fa;
  display: flex;
  justify-content: start;
  color: #fff;
  border-radius: 8px;
  overflow: hidden;
  height: 80px;
  align-items: center;
`;

const Button = styled.button`
  background-color: #7aba56;
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  margin-right: 5px;
  border-radius: 1rem;
  font-size: 12px;
  cursor: pointer;
  margin-top: 5px;
`;

const ThumbImage = styled.img`
  height: 100%;
  object-fit: contain;
  margin-bottom: 10px;
  border-radius: 8px;
`;

const FileInfoSection = ({ recordInfo }) => {
  const dispatch = useDispatch();
  const [viewerData, setViewerData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchViewerUrls = async (id) => {
    setLoading(true);
    try {
      const payload = {
        study_id: id,
        store_id: recordInfo?.store_id,
      };
      const action = await dispatch(getViewerUrls({ payload: payload }));
      if (action?.payload?.status === "success")
        setViewerData(action?.payload?.data);
    } catch (error) {
      console.log("error occured while fetching viewer urls");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (recordInfo?.study_id) fetchViewerUrls(recordInfo.study_id);
  }, [recordInfo?.study_id]);

  const handleScanTmtvClick = async (viewer) => {
    const url = viewer;
    const newWindow = window.open("", "_blank");
    if (!newWindow) {
      alert(
        "Unable to open the new window. Please disable your popup blocker and try again."
      );
      return;
    }
    newWindow.location.href = url;
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection={{ xs: "column", sm: "row" }}
      m={2}
    >
      <Box
        display="flex"
        alignItems="center"
        width={{ xs: "100%", sm: "auto" }}
        mb={{ xs: 2, sm: 0 }}
      >
        <ListItemWrapper>
          <ThumbImages>
            {recordInfo.thumbnail && (
              <ThumbImage src={recordInfo?.thumbnail} alt="records-thumbnail" />
            )}
          </ThumbImages>
        </ListItemWrapper>
      </Box>
      <Box ml={2} width="100%">
        <FileName>
          File Name: {removeSpecialCharacters(recordInfo.patient_name)}
        </FileName>
        {!loading ? (
          <Grid gap={5}>
            {viewerData &&
              Object.keys(viewerData).map((key) => (
                <Button onClick={() => handleScanTmtvClick(viewerData[key])}>
                  {key}
                </Button>
              ))}
          </Grid>
        ) : (
          <ShimmerTitle line={2} gap={10} variant="primary" />
        )}
      </Box>
    </Box>
  );
};

export default FileInfoSection;
